import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { qrCornetsOuter } from "../../../../../redux/slices/qrSettings";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { FrameItem } from "../../framesQr/QrFrameItems";
import {
  Classy,
  Default,
  Dot,
  DotOneClassy,
  ExtraRounded,
  Gear,
  MiddleRounded,
  OneClassy,
  OneClassyRotate,
  Square,
} from "./svg";

const array = [
  { id: 1, pattern: null, component: <Default /> },
  { id: 2, pattern: "square", component: <Square /> },
  { id: 3, pattern: "middle-rounded", component: <MiddleRounded /> },
  { id: 4, pattern: "one-classy", component: <OneClassy /> },
  { id: 5, pattern: "one-classy-rotate", component: <OneClassyRotate /> },
  { id: 6, pattern: "classy", component: <Classy /> },
  { id: 7, pattern: "extra-rounded", component: <ExtraRounded /> },
  { id: 8, pattern: "dot-one-classy", component: <DotOneClassy /> },
  { id: 9, pattern: "dot", component: <Dot /> },
  { id: 10, pattern: "gear", component: <Gear /> },
];

function QrCornetsOuter() {
  const stateCornetsOuter = useSelector(
    (state) => state.qrSettings.cornetsOuter
  );
  const [cornetsOuter, setCornetsOuter] = useState(stateCornetsOuter);

  const dispatch = useDispatch();
  useEffect(() => {
    setCornetsOuter(stateCornetsOuter);
  }, [stateCornetsOuter]);

  useEffect(() => {
    dispatch(qrCornetsOuter(cornetsOuter));
  }, [cornetsOuter]);

  return (
    <Row className="g-3">
      {array.map((item) => (
        <Col xs={3} key={item.id}>
          <FrameItem
            onClick={() => setCornetsOuter(item.pattern)}
            className={classNames(
              "d-flex justify-content-center align-items-center border rounded-1",
              {
                "border-primary": cornetsOuter === item.pattern,
                "border-border-gray": cornetsOuter !== item.pattern,
              }
            )}
            style={{ padding: "20%" }}
          >
            {item.component}
          </FrameItem>
        </Col>
      ))}
    </Row>
  );
}

export default QrCornetsOuter;
